// @ts-nocheck
import React from 'react';
import { sx } from '../sx';

function Slider({ sd }: { sd: any }) {
  return (
    <div>
      <div style={sx(`display:flex;align-items:baseline;gap:8px`)}>
        <span style={sx(`flex:1;min-width:0;font-size:12px;color:${sd.labelFg};overflow:hidden;text-overflow:ellipsis;white-space:nowrap`)}>{sd.label}</span>
        <span key={sd.rk} data-scen-read={sd.field} style={sx(`flex:none;font-size:12px;font-weight:${sd.fw};color:${sd.valFg};font-variant-numeric:tabular-nums`)}>{sd.display}</span>
      </div>
      <input key={sd.rk} type="range" aria-label={sd.label} min={sd.min} max={sd.max} step={sd.step} defaultValue={sd.value} onChange={sd.onChange} onPointerUp={sd.onPointerUp} onKeyUp={sd.onKeyUp} style={sx(`width:100%;margin-top:4px;accent-color:#0052CD;cursor:pointer`)} />
    </div>
  );
}

function SliderGroup({ sd }: { sd: any }) {
  return (
    <div>
      <button type="button" aria-expanded={sd.open} onClick={sd.toggle} style={sx(`width:100%;display:flex;align-items:baseline;gap:8px;padding:0;border:none;background:none;font-family:inherit;text-align:left;cursor:pointer`)}>
        <span aria-hidden="true" style={sx(`flex:none;width:10px;font-size:10px;color:var(--ink-4);transform:rotate(${sd.open ? 90 : 0}deg);transition:transform 120ms`)}>▶</span>
        <span style={sx(`flex:1;min-width:0;font-size:12px;color:${sd.labelFg};overflow:hidden;text-overflow:ellipsis;white-space:nowrap`)}>{sd.label}</span>
        <span style={sx(`flex:none;font-size:11.5px;font-weight:${sd.fw};color:${sd.valFg}`)}>{sd.display}</span>
      </button>
      {sd.open ? (
        <div style={sx(`display:flex;flex-direction:column;gap:9px;margin:8px 0 2px 5px;padding-left:12px;border-left:2px solid #EDF1F8`)}>
          {sd.children.map(c => <Slider key={c.field} sd={c} />)}
        </div>
      ) : null}
    </div>
  );
}

export default function ScenarioRail({ vm }: { vm: any }) {
  if (!vm.scenRail) return null;
  return (
    <aside aria-label="Scenario" style={sx(`position:fixed;top:0;right:0;bottom:0;z-index:50;width:380px;display:flex;flex-direction:column;background:#fff;border-left:1px solid #DCE4F2;box-shadow:-24px 0 40px -30px rgba(8,35,76,0.35)`)}>
      <div style={sx(`flex:none;border-bottom:1px solid #EDF1F8;padding:18px 20px 14px`)}>
        <div style={sx(`display:flex;align-items:center;gap:8px`)}>
          <span style={sx(`flex:1;min-width:0;font-size:11px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:var(--ink-4)`)}>Scenario</span>
          {vm.scenActive ? (
            <button className="gmHover" onClick={vm.resetScenario} style={sx(`flex:none;height:24px;padding:0 10px;border:1px solid #C8D4EA;border-radius:999px;background:#fff;color:var(--ink-4);font-family:inherit;font-size:11px;cursor:pointer`)} data-hover="border-color:#0052CD;color:#0052CD">Reset</button>
          ) : null}
        </div>
        <div style={sx(`font-size:11.5px;color:var(--ink-4);margin-top:3px;line-height:1.45`)}>{vm.scenHeadNote}</div>
      </div>
      <div style={sx(`flex:1;min-height:0;overflow:auto;display:flex;flex-direction:column;gap:9px;padding:14px 20px`)}>
        {vm.scenEmptyNote ? (
          <div style={sx(`padding:12px 14px;border-radius:8px;background:var(--bg-2);font-size:12px;color:var(--ink-3);line-height:1.5`)}>{vm.scenEmptyNote}</div>
        ) : null}
        {(vm.sliders || []).map(sd => (sd.group ? <SliderGroup key={sd.field} sd={sd} /> : <Slider key={sd.field} sd={sd} />))}
      </div>
      <div style={sx(`flex:none;display:flex;align-items:center;gap:8px;flex-wrap:wrap;padding:12px 20px;border-top:1px solid #EDF1F8;background:#fff`)}>
        {vm.scenNamingOff ? (
          <div style={sx(`flex:1;display:flex;gap:8px`)}>
            <button className="gmHover" onClick={vm.exitScenario} style={sx(`flex:none;height:34px;padding:0 15px;border:1px solid #F0B4B6;border-radius:999px;background:#fff;color:#E5484D;font-family:inherit;font-size:12.5px;cursor:pointer`)} data-hover="background:#FDECEC">Exit</button>
            <button className="gmHover" onClick={vm.startSaveScenario} style={sx(`flex:1;height:34px;padding:0 15px;border:none;border-radius:999px;background:#0052CD;color:#fff;font-family:inherit;font-size:12.5px;font-weight:500;cursor:pointer`)} data-hover="background:#003FA0">Save scenario</button>
          </div>
        ) : null}
        {vm.scenNaming ? (
          <div style={sx(`flex:1;display:flex;gap:8px;align-items:center`)}>
            <input className="gmFocus" value={vm.scenName} onChange={vm.onScenName} placeholder="Scenario name" style={sx(`flex:1;min-width:150px;height:34px;padding:0 12px;border:1px solid #C8D4EA;border-radius:8px;font-family:inherit;font-size:12.5px;color:var(--ink);background:#fff;outline:none;box-sizing:border-box`)} />
            <button className="gmHover" onClick={vm.confirmSaveScenario} style={sx(`flex:none;height:34px;padding:0 15px;border:none;border-radius:999px;background:#0052CD;color:#fff;font-family:inherit;font-size:12.5px;font-weight:500;cursor:pointer`)} data-hover="background:#003FA0">Save</button>
            <button onClick={vm.cancelSaveScenario} style={sx(`flex:none;height:34px;padding:0 13px;border:1px solid #C8D4EA;border-radius:999px;background:#fff;color:var(--ink-3);font-family:inherit;font-size:12.5px;cursor:pointer`)}>Cancel</button>
          </div>
        ) : null}
      </div>
    </aside>
  );
}
